import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import aboutHero from "../assets/Hero/hero_13.png";
import aboutImage from "../assets/Hero/hero_1.png";
import "../assets/css/aboutUsPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

const valuesData = [
    {
      icon: "fa fa-users",
      name: "Core Values",
      text: "Customer Focus.<br /> Innovation.<br />Excellence.<br /> Innovation. <br />Integrity. <br />Teamwork. <br />Continuous Improvement."
    },
    {
      icon: "fa fa-anchor",
      name: "Mission",
      text: "To empower businesses with innovative and reliable ICT and software solutions that drive growth, efficiency, and a real competitive edge."
    },
    {
      icon: "fa fa-cogs",
      name: "Vision",
      text: "To be the go-to partner for businesses seeking cutting-edge technology solutions, known for our expertise, innovation, and unwavering commitment to excellence."
    }
  ];

export const AboutUsPage = () => {
  const aboutRef = useRef(null);

  useEffect(() => {
    const elements = aboutRef.current.querySelectorAll(".about-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: aboutRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  return (
    <div id="about-page" ref={aboutRef}>
      {/* Hero Section */}
      <div className="about-hero-section">
        <h1>About Us</h1>
      </div>
      
      {/* About Content */}
      <div className="container about-content-container">
        <div className="row">
          <div className="col-md-6 about-description">
            <h4 className="about-animate">Who We Are</h4>
            <p className="about-animate">
              Infrasoft Solutions Limited is a leading provider of ICT infrastructure and software solutions. 
              We specialize in cloud deployments and bespoke software development, empowering businesses to thrive 
              in today’s digital landscape. We deliver robust, scalable, and innovative solutions tailored to 
              each client's unique needs.
            </p>
            <p className="about-animate">
              With a deep understanding of the ever-evolving tech world, we partner with our clients, guiding them 
              through the complexities of IT to achieve their strategic goals. We're committed to excellence, 
              customer satisfaction, and building long-term relationships.
            </p>

            {/* Why Choose Us Section */}
            <div className="about-why-choose">
                <h5 className="about-animate">Why Choose Us?</h5>
                <ul>
                    <li className="about-animate">Innovative Solutions</li>
                    <li className="about-animate">Highly Skilled Staff</li>
                    <li className="about-animate">Efficient Services</li>
                    <li className="about-animate">Timely Support</li>
                    <li className="about-animate">Highly Reliable</li>
                    <li className="about-animate">Guaranteed Security</li>
                </ul>
            </div>
          </div>
          <div className="col-md-6 about-image-container">
            <img src={aboutImage} className="img-fluid about-animate" alt="About Infrasoft" />
          </div>
        </div>
      </div>
      {/* Purpose, Mission, Vision Section */}
      <div className="container-fluid">
        <div className="about-values-section">
          {valuesData.map((value, index) => (
            <div key={index} className="about-value-card about-animate">
              <i className={value.icon}></i>
              <h4>{value.name}</h4>
              <p dangerouslySetInnerHTML={{ __html: value.text }}></p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
